module.exports = __webpack_public_path__ + "img/symbol_2.662fd333.png";